import {
  ClearButtonType,
  ClearTagsButton,
} from '@aibees/elephant/feature/search-filters/components/filter-tags/components/clear-tags-button';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SelectedTitlesHeaderProps as Props } from './types';

export const SelectedTitlesHeader = memo(
  ({ className, count, onClick }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('SelectedTitlesHeader', className)}
        sx={SX.root}
      >
        <Typography variant="body3" fontWeight={600} color="grey.800">
          Selected Titles
        </Typography>

        <ClearTagsButton
          type={ClearButtonType.CHIP}
          text={'Clear All'}
          count={count}
          onClick={onClick}
        />
      </Styled.Wrapper>
    );
  }
);

SelectedTitlesHeader.displayName = 'SelectedTitlesHeader';
